export const scheduleGameQuery = `query gameScheduleQuery($site: String!, $limit: Int,$offset: Int, $startDate: Int, $endDate: Int, $sortBy: String, $sortOrder: SortOrder,$teamIds: [String!])
{
  gameSchedule(
    site: $site,
    limit: $limit,
    offset: $offset,
    startDate: $startDate,
    endDate: $endDate,
    sortBy: $sortBy,
    sortOrder: $sortOrder,
    teamIds:$teamIds
  ) {limit
    offset
		items{
      id
      title
      currentState
      broadcaster
      gist{
        id
        site
        permalink
        title
        description
        imageGist{
          r32x9
          r16x9
          r4x3
          r3x4
          r1x1
          r9x16
        }
        contentType
        scheduleStartDate
        scheduleEndDate
      }
      homeTeam{
        id
        title
        shortName
        currentSeason
        records {
          PST {
            win
            loss
          }
          REG{
            win
            loss
          }
          PRE{
            win
            loss
          }
          PIT{
            win
            loss
          }
        }
        gist{
          title
          description
          imageGist{
            r16x9
            r4x3
            r3x4
            r1x1
          }
        }
      }
      awayTeam{
        id
        title
        shortName
        currentSeason
        records {
          PST {
            win
            loss
          }
          REG{
            win
            loss
          }
          PRE{
            win
            loss
          }
          PIT{
            win
            loss
          }
        }
        gist{
          title
          description
          imageGist{
            r16x9
            r4x3
            r3x4
            r1x1
          }
        }
      }
      schedules{
        startDate
        endDate
      }
      ticketUrl
      score{
        status
        type
        number
        homePoint
        awayPoint
      }
    }
  }
}`

export const minifiedScheduleQuery = `query gameScheduleQuery($site: String!, $limit: Int,$offset: Int, $startDate: Int, $endDate: Int, $sortBy: String, $sortOrder: SortOrder,$teamIds: [String!]) { gameSchedule( site: $site, limit: $limit, offset: $offset, startDate: $startDate, endDate: $endDate, sortBy: $sortBy, sortOrder: $sortOrder, teamIds:$teamIds ) {limit offset items{ id title currentState broadcaster gist{ id site permalink title description imageGist{ r32x9 r16x9 r4x3 r3x4 r1x1 r9x16 } contentType scheduleStartDate scheduleEndDate } homeTeam{ id title shortName currentSeason records { PST { win loss } REG{ win loss } PRE{ win loss } PIT{ win loss } } gist{ title description imageGist{ r16x9 r4x3 r3x4 r1x1 } } } awayTeam{ id title shortName currentSeason records { PST { win loss } REG{ win loss } PRE{ win loss } PIT{ win loss } } gist{ title description imageGist{ r16x9 r4x3 r3x4 r1x1 } } } schedules{ startDate endDate } ticketUrl score{ status type number homePoint awayPoint } } } }`
export const minifiedScheduleQuerySHA = 'b32a2c78b6bc372801635031dabeeea3cad76fdbafd0f0d1547af4d27be24f86'